import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FactorSubjectForm } from '../forms/FactorSubjectForm';

type FactorSubjectModalProps = {
  selectedFactorUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const FactorSubjectModal = ({ selectedFactorUuid, isOpen, onClose }: FactorSubjectModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={loading}
      title={selectedFactorUuid ? t('factors.editSubjectFactor') : t('factors.addSubjectFactor')}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <FactorSubjectForm selectedFactorUuid={selectedFactorUuid} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
